/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_Publication_DateInputs */

const en_read_along_publication_date = /** @type {(inputs: Read_Along_Publication_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publication date`)
};

const es_read_along_publication_date = /** @type {(inputs: Read_Along_Publication_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha de publicación`)
};

/**
* | output |
* | --- |
* | "Publication date" |
*
* @param {Read_Along_Publication_DateInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_publication_date = /** @type {((inputs?: Read_Along_Publication_DateInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Publication_DateInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_publication_date(inputs)
	return en_read_along_publication_date(inputs)
});